import React from "react";
import Typography from "@material-ui/core/Typography";
import tableicons from "../tableicons";
import MaterialTable from "material-table";
import CheckIcon from "@material-ui/icons/Check";
import {tagResources} from "../endpoints";
import SnackbarAlert from "../components/SnackbarAlert";
import SearchIcon from "@material-ui/icons/Search";
import Grid from "@material-ui/core/Grid";
import {Switch, Tooltip} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";

class Conflictos extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            cargando:true,
            selectedRow: null,
            datos: [],
            openSnackbar: false,
            severity:'',
            message:'',
            checked: {},
        }
    }
    verDetalles = (rowData) =>{
        this.props.history.push("/detalles_conflictos/" + rowData.tag)
    }

    getTagsConflictos = () =>{
        tagResources.getTagsConflictos().then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.status_code === 200){
                this.setState({cargando:false,datos:result.detalle_conflicto})
                for (let i=0; i<result.detalle_conflicto.length; i++){
                    for (let x=0; x<result.detalle_conflicto[i].datos.length; x++){
                        this.setState(
                            ({checked}) => ({
                                checked: {
                                    ...checked,
                                    [result.detalle_conflicto[i].tag +"_"+ result.detalle_conflicto[i].datos[x].id_archivo]: !result.detalle_conflicto[i].datos[x].eliminado,
                                }
                            })
                        );
                    }
                }
            }
            else if (result.status_code === 401){
                this.setState({openSnack:true,cargando:false, severity:result.severity, message:result.message})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            this.setState({cargando:false})
            console.log(error)
        });
    }

    eliminarDescargaTag = (id_archivo,tag) =>{
        this.setState({openSnack:false, severity: null, message:null})
        tagResources.eliminarDescargaTag(id_archivo,tag).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.message){
                this.setState({openSnack:true, severity: result.severity, message:result.message})
                this.setState(
                    ({checked}) => ({
                        checked: {
                            ...checked,
                            [tag +"_"+ id_archivo]: !this.state.checked[tag +"_"+ id_archivo],
                        }
                    })
                );
            }
            else {
                throw new Error('Something went wrong ...');
            }

        }).catch(error=> {
            this.setState({openSnack:true, severity: "error", message:"Ha ocurrido un error inesperado"})
            console.log(error)
        });
    }

    recuperarDescargaTag = (id_archivo,tag) =>{
        this.setState({openSnack:false, severity: null, message:null})
        tagResources.recuperarDescargaTag(id_archivo,tag).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.message){
                this.setState({openSnack:true, severity: result.severity, message:result.message})
                //this.getTagsConflictos()
                this.setState(
                    ({checked}) => ({
                        checked: {
                            ...checked,
                            [tag +"_"+ id_archivo]: !this.state.checked[tag +"_"+ id_archivo],
                        }
                    })
                );
            }
            else {
                throw new Error('Something went wrong ...');
            }

        }).catch(error=> {
            this.setState({openSnack:true, severity: "error", message:"Ha ocurrido un error inesperado"})
            console.log(error)
        });

    }

    handleChange = (descarga,rowData) => {
        if (!this.state.checked[rowData.tag+"_"+descarga.id_archivo]){
            this.recuperarDescargaTag(descarga.id_archivo,rowData.tag)
        }
        else{
            this.eliminarDescargaTag(descarga.id_archivo,rowData.tag)
        }


    };

    componentDidMount() {
        this.getTagsConflictos()
    }

    render() {
        return (
            <div>
                <Typography variant="h4" gutterBottom>Duplicados</Typography>

                <MaterialTable
                    localization={{
                        toolbar: {
                            searchPlaceholder: 'Buscar',
                        },
                        header: {
                            actions: 'Acciones'
                        },
                        body:{
                            emptyDataSourceMessage: 'No hay datos para mostrar'
                        },
                    }}
                    isLoading={this.state.cargando}
                    options={{
                        pageSize: 50,
                        pageSizeOptions: [10, 25, 50, 100],
                        actionsColumnIndex: -1,
                        rowStyle: rowData => ({
                            backgroundColor: (this.state.selectedRow === rowData.tableData.id) ? '#dbe9fc' : '#FFF'
                        }),
                        searchFieldStyle: {
                            width: "auto",
                        },
                        padding: "dense"
                    }}
                    icons={tableicons}
                    title=""
                    data={this.state.datos}
                    columns={[
                        { title: 'Tag', field: 'tag',
                            cellStyle: {
                                width: 100,
                                maxWidth: 100,
                            },
                            headerStyle: {
                                width: 100,
                                maxWidth: 100
                            }},
                        { title: 'Ubicación', field: 'ubicacion_path',
                            cellStyle: {
                                width: 700,
                                maxWidth: 700,
                            },
                            headerStyle: {
                                width: 700,
                                maxWidth: 700
                            }},
                        { title: 'N° descargas', field: 'descargas' },
                        { title: 'Cantidad capt.', field: 'cantidad'},
                        { title: 'Revisado', field: 'resuelto',
                            cellStyle: {
                                width: 100,
                                maxWidth: 100,
                            },
                            headerStyle: {
                                width: 100,
                                maxWidth: 100
                            },
                            render: rowData => (rowData.resuelto ? <CheckIcon/> : null),}
                    ]}
                    detailPanel={rowData => {
                        return (
                            <Grid container direction="row" alignItems="center">
                                {rowData.datos.map(descarga=>{
                                    return (
                                        <Grid container style={{border:'1px solid black'}} direction="row" alignItems="center" key={descarga.id_archivo}>
                                            <Grid style={{marginLeft:'10px'}} item xs={2}>
                                                <Typography>N° Descarga: {descarga.id_archivo} </Typography>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Typography>Cantidad: {descarga.cantidad}</Typography>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <Typography>Operador: {descarga.nombre}</Typography>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Grid container direction={"row"} alignItems="center">
                                                    <Typography>Eliminado</Typography>
                                                    <Switch
                                                        id = {rowData.tag +"_"+ descarga.id_archivo}
                                                        checked={this.state.checked[rowData.tag +"_"+ descarga.id_archivo]}
                                                        onClick={() => this.handleChange(descarga, rowData)}
                                                        color={"primary"}
                                                        inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                    />
                                                    <Typography>Aceptado</Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={1}>
                                                <Tooltip title={"Ver detalle descarga"}>
                                                    <IconButton onClick={()=>{ this.verDetalles(rowData)}} color={"primary"} size="medium">
                                                        <SearchIcon/>
                                                    </IconButton>
                                                </Tooltip>
                                            </Grid>
                                        </Grid>)
                                })}
                            </Grid>
                        )
                    }}
                    onRowClick={(event, rowData, togglePanel) => {
                        togglePanel();
                        this.setState({selectedRow: rowData.tableData.id})}}
                    /*actions={[

                        {
                            icon:  () => <SearchIcon style={{fontSize:27, margin:4}}/>,
                            tooltip: 'Ver detalle conflicto',
                            onClick: (event, rowData) => this.verDetalles(rowData),
                        },
                        rowData => ({
                            icon:  () =><CheckIcon style={{fontSize:27, margin:4}}/>,
                            tooltip: 'Marcar duplicado como revisado',
                            onClick: (event, rowData) => this.resolverConflictoTag(rowData),
                            hidden: rowData.resuelto === true }),
                        rowData => ({
                            icon:  () =><ClearIcon style={{fontSize:27, margin:4}}/>,
                            tooltip: 'Eliminar revisiÃ³n de duplicado',
                            onClick: (event, rowData) => this.desResolverConflictoTag(rowData),
                            hidden: rowData.resuelto === false})
                    ]}*/
                />
                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
            </div>
        )
    }
}

export default Conflictos;